import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../services';
import { error } from 'util';
import { element } from 'protractor';
import { Element } from '@angular/compiler';



@Component({
    templateUrl: './login-view.component.html',
    styleUrls: ['./login-view.component.scss']
})

export class LoginViewComponent {

    username: string = "";
    password: string = "";

    errorMsg: string = "";

    constructor(private authService: AuthService,
                private router: Router)
    {

    }

    login() {
        this.authService.login(this.username, this.password).subscribe( res => {            
            if (res) {                
                this.router.navigate(['dashboard']);
                this.toggleErrorMsg(false);
            } else {                
                this.toggleErrorMsg(true);
            }
        },
        err => {
            this.toggleErrorMsg(true);            
        });
    }

    toggleErrorMsg(visible: boolean) {
        if (visible) {
            this.errorMsg = "Please check username and/or password";
        } else {
            this.errorMsg = "";            
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/views/login-view/login-view.component.ts